import axios from 'axios'

// These calls go straight to the Meta Graph API, not our backend, so they must NOT use
// axiosInstance: its interceptor attaches our Authorization/Org-Id/X-Client-Type headers to every
// request, which (a) turns this into a CORS-preflighted request that Facebook rejects and (b) leaks
// our bearer token to a third party. A bare axios client sends only the query-string token.
const getAccounts = async (userToken) => {
  const url = `https://graph.facebook.com/v20.0/me/accounts?access_token=${userToken}`

  // Step 1: Fetch the accounts
  const accountsResponse = await axios.get(url)

  const accountsData = accountsResponse.data.data
  // Step 2: Fetch the profile pictures for each account
  const accountsWithImages = await Promise.all(
    accountsData.map(async (account) => {
      const pictureUrl = `https://graph.facebook.com/v20.0/${account.id}/picture?redirect=false&access_token=${userToken}`

      const pictureResponse = await axios.get(pictureUrl)

      const pictureData = pictureResponse.data

      // Add the picture URL to the account object
      return {
        ...account,
        picture: pictureData.data.url,
      }
    }),
  )

  return accountsWithImages
}

export default getAccounts
